import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    copyLink: (isRootFolder: boolean) => string | React.ReactNode;
    createShareLink: string;
    createUploadLink: string;
    delete: string;
    downloadAllFiles: string;
    inviteMembers: string;
    manageMembers: string;
    rename: string;
};
export type Deps = {
    String: any;
};
export default {
    DEFINE(_messages: Text, { String }: Deps): void {
        return Object.defineProperties(this, {
            /** Menu item label for copying the current folder or project link */
            copyLink: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (isRootFolder: boolean) => { const value = String(isRootFolder); return __intl__.intl().formatMessage({ id: "FolderMenu.copyLink.0?c=2ctq1t8hbuy4l", defaultMessage: "{value, select, true {Copy Project URL} other {Copy Folder URL}}" }, { value: value }); });
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label for creating a share link */
            createShareLink: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FolderMenu.createShareLink?c=34u6g57b1fztn", defaultMessage: "Create Share Link" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label for creating an upload link */
            createUploadLink: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FolderMenu.createUploadLink?c=3kq1erda5182o", defaultMessage: "Create Upload Link" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label for deleting the folder */
            delete: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FolderMenu.delete?c=7nzkz7owpk0x", defaultMessage: "Delete" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label for downloading all assets */
            downloadAllFiles: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FolderMenu.downloadAllFiles?c=vmh79u9lkb2g", defaultMessage: "Download All Assets" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label for inviting members */
            inviteMembers: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FolderMenu.inviteMembers?c=3akii96mywnxz", defaultMessage: "Invite Members" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label for managing members */
            manageMembers: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FolderMenu.manageMembers?c=tklamxbrwz1l", defaultMessage: "Manage Members" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label for renaming the folder */
            rename: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FolderMenu.rename?c=2xvuf86b5nq1g", defaultMessage: "Rename" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps: Deps): void;
};
